// extracted by mini-css-extract-plugin
module.exports = {"viewer":"common-BookletViewer__viewer--2ftCo","loadingIndicator":"common-BookletViewer__loadingIndicator--1twJt"};